import { render, staticRenderFns } from "./GeneralOverview.vue?vue&type=template&id=49f55e45&scoped=true"
import script from "./GeneralOverview.vue?vue&type=script&lang=js"
export * from "./GeneralOverview.vue?vue&type=script&lang=js"
import style0 from "./GeneralOverview.vue?vue&type=style&index=0&id=49f55e45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f55e45",
  null
  
)

export default component.exports